var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "DashboardCardScaffold",
    {
      attrs: { isAdmin: _vm.isAdmin },
      scopedSlots: _vm._u(
        [
          {
            key: "header",
            fn: function () {
              return [
                _c(
                  "div",
                  {
                    staticClass:
                      "flex flex-inline items-center absolute left-1/2 pl-6",
                  },
                  [
                    _c(
                      "RouterLink",
                      {
                        staticClass: "hover:text-primary-500",
                        attrs: {
                          to: {
                            name: _vm.routes.COMPANY_DATABASE,
                          },
                        },
                      },
                      [
                        _c("span", { staticClass: "flex font-bold text-lg" }, [
                          _vm._v("Contractors"),
                        ]),
                      ]
                    ),
                  ],
                  1
                ),
                _c(
                  "CardItemScaffold",
                  {
                    staticClass: "mt-20 text-innerCard-primary",
                    attrs: {
                      itemNumber: _vm.customRequestTotal,
                      itemTitle: "External Sourcing",
                      itemLink: _vm.requestsLink,
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "icon",
                        fn: function () {
                          return [
                            _c("SimplePersonIcon", {
                              staticClass:
                                "fill-current text-primary-500 h-5 w-5",
                            }),
                          ]
                        },
                        proxy: true,
                      },
                    ]),
                  },
                  [
                    _c("p", { staticClass: "text-gray-600 text-sm" }, [
                      _vm._v(
                        "A Manager has requested access to a Contractor and requires approval. "
                      ),
                    ]),
                  ]
                ),
                _c(
                  "CardItemScaffold",
                  {
                    staticClass: "mt-20 text-innerCard-primary",
                    attrs: {
                      itemNumber: _vm.contractorRequestsTotal,
                      itemTitle: _vm.requestItemTitle,
                      itemLink: _vm.requestsLink,
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "icon",
                        fn: function () {
                          return [
                            _c("SimplePersonIcon", {
                              staticClass:
                                "fill-current text-primary-500 h-5 w-5",
                            }),
                          ]
                        },
                        proxy: true,
                      },
                    ]),
                  },
                  [
                    _c("p", { staticClass: "text-gray-600 text-sm" }, [
                      _vm._v(
                        "A Manager has requested access to a Contractor and requires approval. "
                      ),
                    ]),
                  ]
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "uploadbutton",
            fn: function () {
              return [
                _c("DashboardContractorInvite", {
                  staticClass: "w-72",
                  attrs: {
                    actionButtonContent: "Invite Resources",
                    companyId: _vm.companyId,
                    currentUserId: _vm.currentUserId,
                    companyBusinessName: _vm.companyBusinessName,
                    isManager: _vm.isManager,
                  },
                }),
              ]
            },
            proxy: true,
          },
          _vm.isManager
            ? {
                key: "contractorsheader",
                fn: function () {
                  return [
                    _c(
                      "span",
                      { staticClass: "font-bold text-lg mt-24 ml-8 bg-white" },
                      [_vm._v("Talent Directory")]
                    ),
                  ]
                },
                proxy: true,
              }
            : null,
          {
            key: "avatarpointers",
            fn: function () {
              return [
                _vm.contractors
                  ? _c(
                      "div",
                      { staticClass: "flex ml-16 -mt-10 contractors" },
                      [
                        _c(
                          "div",
                          { staticClass: "flex items-center" },
                          [
                            _vm._l(
                              _vm.contractors.slice(0, 3),
                              function (contractor) {
                                return _c("div", { key: contractor.id }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "rounded-full transform hover:scale-125 -m-1 mt-1",
                                    },
                                    [
                                      _c(
                                        "Tooltip",
                                        {
                                          attrs: {
                                            title: _vm.getContractorFullname(
                                              contractor.user
                                            ),
                                            variant: _vm.TooltipVariants.DARK,
                                            placement: "top",
                                          },
                                        },
                                        [
                                          contractor.user.avatar
                                            ? [
                                                _c(
                                                  "RouterLink",
                                                  {
                                                    attrs: {
                                                      to: {
                                                        name: _vm.routes
                                                          .CONTRACTOR_DETAILS_ABOUT,
                                                        params: {
                                                          id: contractor.id,
                                                        },
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._t(
                                                      "image",
                                                      function () {
                                                        return [
                                                          _c("S3Image", {
                                                            class: [
                                                              _vm.defaultImageClasses,
                                                              _vm.avatarStyleClasses,
                                                            ],
                                                            attrs: {
                                                              s3FileKey:
                                                                contractor.user
                                                                  .avatar,
                                                            },
                                                          }),
                                                        ]
                                                      },
                                                      {
                                                        defaultClasses: [
                                                          _vm.defaultImageClasses,
                                                          _vm.avatarStyleClasses,
                                                        ],
                                                        image:
                                                          contractor.user
                                                            .avatar,
                                                      }
                                                    ),
                                                  ],
                                                  2
                                                ),
                                              ]
                                            : [
                                                _c(
                                                  "RouterLink",
                                                  {
                                                    attrs: {
                                                      to: {
                                                        name: _vm.routes
                                                          .CONTRACTOR_DETAILS_ABOUT,
                                                        params: {
                                                          id: contractor.id,
                                                        },
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._t(
                                                      "initial",
                                                      function () {
                                                        return [
                                                          _c(
                                                            "span",
                                                            {
                                                              class: [
                                                                _vm.defaultInitialsClasses,
                                                                _vm.avatarStyleClasses,
                                                              ],
                                                              style:
                                                                _vm.bgStyle,
                                                            },
                                                            [
                                                              contractor.user &&
                                                              contractor.user
                                                                .given_name &&
                                                              contractor.user
                                                                .family_name
                                                                ? _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "text-xs leading-none font-semibold text-white",
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          contractor.user.given_name
                                                                            .trimStart()[0]
                                                                            .toUpperCase()
                                                                        ) +
                                                                          _vm._s(
                                                                            contractor.user.family_name
                                                                              .trimStart()[0]
                                                                              .toUpperCase()
                                                                          ) +
                                                                          " "
                                                                      ),
                                                                    ]
                                                                  )
                                                                : _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "text-sm leading-none text-white",
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          _vm.initial
                                                                        ) + " "
                                                                      ),
                                                                    ]
                                                                  ),
                                                            ]
                                                          ),
                                                        ]
                                                      },
                                                      {
                                                        defaultClasses: [
                                                          _vm.defaultInitialsClasses,
                                                          _vm.avatarStyleClasses,
                                                        ],
                                                      }
                                                    ),
                                                  ],
                                                  2
                                                ),
                                              ],
                                        ],
                                        2
                                      ),
                                    ],
                                    1
                                  ),
                                ])
                              }
                            ),
                            _c(
                              "RouterLink",
                              {
                                staticClass: "hover:text-primary-500",
                                attrs: { to: _vm.routes.COMPANY_DATABASE },
                              },
                              [
                                _vm.contractors.length > 3
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "flex w-8 h-8 rounded-full border-gray-200 border -m-1 transform hover:scale-125 -mb-4 bg-blue-200 text-center",
                                      },
                                      [
                                        _c("PlusIcon", {
                                          staticClass:
                                            "fill-current w-2 h-2 mt-2.5 ml-1.5",
                                        }),
                                        _c(
                                          "p",
                                          {
                                            staticClass:
                                              "mt-1 text-sm font-medium",
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.contractors.length - 3)
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ]
                            ),
                          ],
                          2
                        ),
                      ]
                    )
                  : _vm._e(),
                _c("div", { staticClass: "flex ml-52 -mt-9 newContractors" }, [
                  _c(
                    "div",
                    { staticClass: "flex items-center" },
                    [
                      _vm._l(
                        _vm.contractorsAvatar.slice(0, 3),
                        function (user) {
                          return _c("div", { key: user.id }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "rounded-full transform hover:scale-125 -m-1 mt-2",
                              },
                              [
                                _c(
                                  "Tooltip",
                                  {
                                    attrs: {
                                      title: _vm.getContractorFullname(
                                        user.user
                                      ),
                                      variant: _vm.TooltipVariants.DARK,
                                      placement: "top",
                                    },
                                  },
                                  [
                                    user.user.avatar
                                      ? [
                                          _c(
                                            "RouterLink",
                                            {
                                              attrs: {
                                                to: {
                                                  name: _vm.routes
                                                    .CONTRACTOR_DETAILS_ABOUT,
                                                  params: { id: user.id },
                                                },
                                              },
                                            },
                                            [
                                              _vm._t(
                                                "image",
                                                function () {
                                                  return [
                                                    _c("S3Image", {
                                                      class: [
                                                        _vm.defaultImageClasses,
                                                        _vm.avatarStyleClasses,
                                                      ],
                                                      attrs: {
                                                        s3FileKey:
                                                          user.user.avatar,
                                                      },
                                                    }),
                                                  ]
                                                },
                                                {
                                                  defaultClasses: [
                                                    _vm.defaultImageClasses,
                                                    _vm.avatarStyleClasses,
                                                  ],
                                                  image: user.user.avatar,
                                                }
                                              ),
                                            ],
                                            2
                                          ),
                                        ]
                                      : [
                                          _c(
                                            "RouterLink",
                                            {
                                              attrs: {
                                                to: {
                                                  name: _vm.routes
                                                    .CONTRACTOR_DETAILS_ABOUT,
                                                  params: { id: user.id },
                                                },
                                              },
                                            },
                                            [
                                              _vm._t(
                                                "initial",
                                                function () {
                                                  return [
                                                    _c(
                                                      "span",
                                                      {
                                                        class: [
                                                          _vm.defaultInitialsClasses,
                                                          _vm.avatarStyleClasses,
                                                        ],
                                                        style: _vm.bgStyle,
                                                      },
                                                      [
                                                        user.user &&
                                                        user.user.given_name &&
                                                        user.user.family_name
                                                          ? _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "text-xs leading-none font-semibold text-white",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    user.user.given_name
                                                                      .trimStart()[0]
                                                                      .toUpperCase()
                                                                  ) +
                                                                    _vm._s(
                                                                      user.user.family_name
                                                                        .trimStart()[0]
                                                                        .toUpperCase()
                                                                    ) +
                                                                    " "
                                                                ),
                                                              ]
                                                            )
                                                          : _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "text-sm leading-none text-white",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.initial
                                                                  ) + " "
                                                                ),
                                                              ]
                                                            ),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                                {
                                                  defaultClasses: [
                                                    _vm.defaultInitialsClasses,
                                                    _vm.avatarStyleClasses,
                                                  ],
                                                }
                                              ),
                                            ],
                                            2
                                          ),
                                        ],
                                  ],
                                  2
                                ),
                              ],
                              1
                            ),
                          ])
                        }
                      ),
                      _c(
                        "RouterLink",
                        {
                          staticClass: "hover:text-primary-500",
                          attrs: { to: _vm.routes.COMPANY_DATABASE },
                        },
                        [
                          _vm.contractorsAvatar.length > 3
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "flex w-8 h-8 rounded-full border-gray-200 border -m-1 transform hover:scale-125 -mb-4 bg-blue-200",
                                },
                                [
                                  _c("PlusIcon", {
                                    staticClass:
                                      "fill-current w-2 h-2 mt-2.5 ml-1.5",
                                  }),
                                  _c(
                                    "p",
                                    { staticClass: "mt-1 text-sm font-medium" },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.contractorsAvatar.length - 3)
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ]
                      ),
                    ],
                    2
                  ),
                ]),
              ]
            },
            proxy: true,
          },
          _vm.isAdmin
            ? {
                key: "recruiting",
                fn: function () {
                  return [
                    _c(
                      "span",
                      { staticClass: "font-bold text-lg mt-24 ml-8 bg-white" },
                      [_vm._v("Recruiting")]
                    ),
                    _c("PostingModalWithButton", {
                      staticClass: "flex flex-grow justify-end",
                      attrs: {
                        companyId: _vm.companyId,
                        currentUser: _vm.currentUser,
                      },
                    }),
                  ]
                },
                proxy: true,
              }
            : null,
          _vm.isAdmin
            ? {
                key: "recruitingcards",
                fn: function () {
                  return [
                    _c(
                      "CardItemScaffold",
                      {
                        staticClass: "text-innerCard-primary",
                        attrs: {
                          itemNumber: _vm.postingsTotal,
                          itemTitle: "Active Postings",
                          flexRow: "",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "icon",
                              fn: function () {
                                return [
                                  _c("JobPostingIcon", {
                                    staticClass:
                                      "h-5 w-5 fill-current text-primary-500",
                                  }),
                                ]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          false,
                          727968257
                        ),
                      },
                      [
                        _vm.postings.length
                          ? _c(
                              "div",
                              { staticClass: "flex items-center" },
                              _vm._l(_vm.postings, function (posting, index) {
                                return _c("CircleWithInitials", {
                                  key: index,
                                  staticClass: "mr-1",
                                  attrs: {
                                    showTooltip: "",
                                    title: posting.name,
                                    id: posting.id,
                                    route: _vm.routes.RECRUITING_POSTING,
                                  },
                                })
                              }),
                              1
                            )
                          : _vm._e(),
                      ]
                    ),
                    _c(
                      "CardItemScaffold",
                      {
                        staticClass: "text-innerCard-primary",
                        attrs: {
                          itemNumber: _vm.newPostingsTotal,
                          itemTitle: "New Postings",
                          flexRow: "",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "icon",
                              fn: function () {
                                return [
                                  _c("JobPostingIcon", {
                                    staticClass:
                                      "h-5 w-5 fill-current text-primary-500",
                                  }),
                                ]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          false,
                          727968257
                        ),
                      },
                      [
                        _vm.newPostings.length
                          ? _c(
                              "div",
                              { staticClass: "flex items-center" },
                              _vm._l(
                                _vm.newPostings,
                                function (posting, index) {
                                  return _c("CircleWithInitials", {
                                    key: index,
                                    staticClass: "mr-1",
                                    attrs: {
                                      showTooltip: "",
                                      title: posting.name,
                                      id: posting.id,
                                      route: _vm.routes.RECRUITING_POSTING,
                                    },
                                  })
                                }
                              ),
                              1
                            )
                          : _vm._e(),
                      ]
                    ),
                    _c("CardItemScaffold", {
                      staticClass: "text-innerCard-primary",
                      attrs: {
                        itemNumber: _vm.applicantsTotal,
                        itemTitle: "Applicants",
                        flexRow: "",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "icon",
                            fn: function () {
                              return [
                                _c("SimplePersonIcon", {
                                  staticClass:
                                    "h-5 w-5 fill-current text-primary-500",
                                }),
                              ]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        false,
                        1548329797
                      ),
                    }),
                  ]
                },
                proxy: true,
              }
            : null,
          _vm.isManager
            ? {
                key: "mycontractors",
                fn: function () {
                  return [
                    _c(
                      "span",
                      { staticClass: "font-bold text-lg mt-8 ml-8 bg-white" },
                      [_vm._v("My Talent Directory")]
                    ),
                  ]
                },
                proxy: true,
              }
            : null,
          _vm.isManager
            ? {
                key: "mycontractorscards",
                fn: function () {
                  return [
                    _c(
                      "CardItemScaffold",
                      {
                        staticClass: "mb-2 text-innerCard-primary",
                        attrs: {
                          itemNumber: _vm.myContractorsTotal,
                          itemTitle: "Contractors",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "icon",
                              fn: function () {
                                return [
                                  _c("SimplePersonIcon", {
                                    staticClass:
                                      "fill-current text-primary-500 h-5 w-5",
                                  }),
                                ]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          false,
                          917959621
                        ),
                      },
                      [
                        _c("ItemChipsWithMore", {
                          attrs: {
                            items: _vm.myContractorsInfo,
                            moreNumber: _vm.myContractorsTotal,
                            routeName: _vm.routes.CONTRACTOR_DETAILS_ABOUT,
                            showNotAvailable: false,
                            navigateTo: {
                              name: _vm.routes.MANAGER_CONTRACTOR_DATABASE,
                            },
                            maxChipWidth: "max-w-40",
                            isPerson: "",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "CardItemScaffold",
                      {
                        staticClass: "text-innerCard-primary",
                        attrs: {
                          itemNumber: _vm.myNewContractorsTotal,
                          itemTitle: _vm.myNewContractorsText,
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "icon",
                              fn: function () {
                                return [
                                  _c("SimplePersonIcon", {
                                    staticClass:
                                      "fill-current text-primary-500 h-5 w-5",
                                  }),
                                ]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          false,
                          917959621
                        ),
                      },
                      [
                        _c("ItemChipsWithMore", {
                          attrs: {
                            items: _vm.myNewContractorsInfo,
                            moreNumber: _vm.myNewContractorsTotal,
                            routeName: _vm.routes.CONTRACTOR_DETAILS_ABOUT,
                            showNotAvailable: false,
                            navigateTo: { name: _vm.routes.COMPANY_DATABASE },
                            isPerson: "",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "CardItemScaffold",
                      {
                        staticClass: "text-innerCard-primary",
                        attrs: {
                          itemNumber: _vm.total,
                          itemTitle: "Favourites",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "icon",
                              fn: function () {
                                return [
                                  _c("SimplePersonIcon", {
                                    staticClass:
                                      "fill-current text-primary-500 h-5 w-5",
                                  }),
                                ]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          false,
                          917959621
                        ),
                      },
                      [
                        _c("ItemChipsWithMore", {
                          attrs: {
                            showNotAvailable: false,
                            items: _vm.favorites,
                            moreNumber: _vm.total,
                            routeName: _vm.routes.CONTRACTOR_DETAILS_ABOUT,
                            navigateTo: { name: _vm.routes.COMPANY_DATABASE },
                            maxChipWidth: "max-w-40",
                            isPerson: "",
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                },
                proxy: true,
              }
            : null,
          _vm.isManager
            ? {
                key: "mycontractorsavatarpointers",
                fn: function () {
                  return [
                    _vm.managerDB.contractors
                      ? _c(
                          "div",
                          { staticClass: "flex ml-8 -mt-9 contractors" },
                          [
                            _c(
                              "div",
                              { staticClass: "flex items-center" },
                              [
                                _vm._l(
                                  _vm.managerDB.contractors.slice(0, 3),
                                  function (contractor) {
                                    return _c(
                                      "div",
                                      { key: contractor.contractor.id },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "rounded-full transform hover:scale-125 -m-1 mt-1",
                                          },
                                          [
                                            _c(
                                              "Tooltip",
                                              {
                                                attrs: {
                                                  title:
                                                    _vm.getContractorFullname(
                                                      contractor.contractor.user
                                                    ),
                                                  variant:
                                                    _vm.TooltipVariants.DARK,
                                                  placement: "top",
                                                },
                                              },
                                              [
                                                contractor.contractor.user &&
                                                contractor.contractor.user
                                                  .avatar
                                                  ? [
                                                      _c(
                                                        "RouterLink",
                                                        {
                                                          attrs: {
                                                            to: {
                                                              name: _vm.routes
                                                                .CONTRACTOR_DETAILS_ABOUT,
                                                              params: {
                                                                id: contractor
                                                                  .contractor
                                                                  .id,
                                                              },
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _vm._t(
                                                            "image",
                                                            function () {
                                                              return [
                                                                _c("S3Image", {
                                                                  class: [
                                                                    _vm.defaultImageClasses,
                                                                    _vm.avatarStyleClasses,
                                                                  ],
                                                                  attrs: {
                                                                    s3FileKey:
                                                                      contractor
                                                                        .contractor
                                                                        .user
                                                                        .avatar,
                                                                  },
                                                                }),
                                                              ]
                                                            },
                                                            {
                                                              defaultClasses: [
                                                                _vm.defaultImageClasses,
                                                                _vm.avatarStyleClasses,
                                                              ],
                                                              image:
                                                                contractor
                                                                  .contractor
                                                                  .user.avatar,
                                                            }
                                                          ),
                                                        ],
                                                        2
                                                      ),
                                                    ]
                                                  : [
                                                      _c(
                                                        "RouterLink",
                                                        {
                                                          attrs: {
                                                            to: {
                                                              name: _vm.routes
                                                                .CONTRACTOR_DETAILS_ABOUT,
                                                              params: {
                                                                id: contractor
                                                                  .contractor
                                                                  .id,
                                                              },
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _vm._t(
                                                            "initial",
                                                            function () {
                                                              return [
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    class: [
                                                                      _vm.defaultInitialsClasses,
                                                                      _vm.avatarStyleClasses,
                                                                    ],
                                                                    style:
                                                                      _vm.bgStyle,
                                                                  },
                                                                  [
                                                                    contractor
                                                                      .contractor
                                                                      .user &&
                                                                    contractor
                                                                      .contractor
                                                                      .user
                                                                      .given_name &&
                                                                    contractor
                                                                      .contractor
                                                                      .user
                                                                      .family_name
                                                                      ? _c(
                                                                          "span",
                                                                          {
                                                                            staticClass:
                                                                              "text-xs leading-none font-semibold text-white",
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              " " +
                                                                                _vm._s(
                                                                                  contractor.contractor.user.given_name
                                                                                    .trimStart()[0]
                                                                                    .toUpperCase()
                                                                                ) +
                                                                                _vm._s(
                                                                                  contractor.contractor.user.family_name
                                                                                    .trimStart()[0]
                                                                                    .toUpperCase()
                                                                                ) +
                                                                                " "
                                                                            ),
                                                                          ]
                                                                        )
                                                                      : _c(
                                                                          "span",
                                                                          {
                                                                            staticClass:
                                                                              "text-sm leading-none text-white",
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                _vm.initial
                                                                              ) +
                                                                                " "
                                                                            ),
                                                                          ]
                                                                        ),
                                                                  ]
                                                                ),
                                                              ]
                                                            },
                                                            {
                                                              defaultClasses: [
                                                                _vm.defaultInitialsClasses,
                                                                _vm.avatarStyleClasses,
                                                              ],
                                                            }
                                                          ),
                                                        ],
                                                        2
                                                      ),
                                                    ],
                                              ],
                                              2
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    )
                                  }
                                ),
                                _c(
                                  "RouterLink",
                                  {
                                    staticClass: "hover:text-primary-500",
                                    attrs: { to: _vm.routes.COMPANY_DATABASE },
                                  },
                                  [
                                    _vm.managerDB.contractors.length > 3
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "flex w-8 h-8 rounded-full border-gray-200 border -m-1 transform hover:scale-125 -mb-4 bg-blue-200",
                                          },
                                          [
                                            _c("PlusIcon", {
                                              staticClass:
                                                "fill-current w-2 h-2 mt-2.5 ml-1.5",
                                            }),
                                            _c(
                                              "p",
                                              {
                                                staticClass:
                                                  "mt-1 text-sm font-medium",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.managerDB.contractors
                                                      .length - 3
                                                  )
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ]
                                ),
                              ],
                              2
                            ),
                          ]
                        )
                      : _vm._e(),
                  ]
                },
                proxy: true,
              }
            : null,
          _vm.isManager
            ? {
                key: "mycontractorsavatarpointers2",
                fn: function () {
                  return [
                    _vm.managerDB.newContractors
                      ? _c(
                          "div",
                          { staticClass: "flex -mt-9 newContractors" },
                          [
                            _c(
                              "div",
                              { staticClass: "flex items-center" },
                              [
                                _vm._l(
                                  _vm.managerDB.newContractors.slice(0, 3),
                                  function (user) {
                                    return _c(
                                      "div",
                                      { key: user.contractor.id },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "rounded-full transform hover:scale-125 -m-1 mt-1",
                                          },
                                          [
                                            _c(
                                              "Tooltip",
                                              {
                                                attrs: {
                                                  title:
                                                    _vm.getContractorFullname(
                                                      user.contractor.user
                                                    ),
                                                  variant:
                                                    _vm.TooltipVariants.DARK,
                                                  placement: "top",
                                                },
                                              },
                                              [
                                                user.contractor.user &&
                                                user.contractor.user.avatar
                                                  ? [
                                                      _c(
                                                        "RouterLink",
                                                        {
                                                          attrs: {
                                                            to: {
                                                              name: _vm.routes
                                                                .CONTRACTOR_DETAILS_ABOUT,
                                                              params: {
                                                                id: user
                                                                  .contractor
                                                                  .id,
                                                              },
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _vm._t(
                                                            "image",
                                                            function () {
                                                              return [
                                                                _c("S3Image", {
                                                                  class: [
                                                                    _vm.defaultImageClasses,
                                                                    _vm.avatarStyleClasses,
                                                                  ],
                                                                  attrs: {
                                                                    s3FileKey:
                                                                      user
                                                                        .contractor
                                                                        .user
                                                                        .avatar,
                                                                  },
                                                                }),
                                                              ]
                                                            },
                                                            {
                                                              defaultClasses: [
                                                                _vm.defaultImageClasses,
                                                                _vm.avatarStyleClasses,
                                                              ],
                                                              image:
                                                                user.contractor
                                                                  .user.avatar,
                                                            }
                                                          ),
                                                        ],
                                                        2
                                                      ),
                                                    ]
                                                  : [
                                                      _c(
                                                        "RouterLink",
                                                        {
                                                          attrs: {
                                                            to: {
                                                              name: _vm.routes
                                                                .CONTRACTOR_DETAILS_ABOUT,
                                                              params: {
                                                                id: user
                                                                  .contractor
                                                                  .id,
                                                              },
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _vm._t(
                                                            "initial",
                                                            function () {
                                                              return [
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    class: [
                                                                      _vm.defaultInitialsClasses,
                                                                      _vm.avatarStyleClasses,
                                                                    ],
                                                                    style:
                                                                      _vm.bgStyle,
                                                                  },
                                                                  [
                                                                    user
                                                                      .contractor
                                                                      .user &&
                                                                    user
                                                                      .contractor
                                                                      .user
                                                                      .given_name &&
                                                                    user
                                                                      .contractor
                                                                      .user
                                                                      .family_name
                                                                      ? _c(
                                                                          "span",
                                                                          {
                                                                            staticClass:
                                                                              "text-xs leading-none font-semibold text-white",
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              " " +
                                                                                _vm._s(
                                                                                  user.contractor.user.given_name
                                                                                    .trimStart()[0]
                                                                                    .toUpperCase()
                                                                                ) +
                                                                                _vm._s(
                                                                                  user.contractor.user.family_name
                                                                                    .trimStart()[0]
                                                                                    .toUpperCase()
                                                                                ) +
                                                                                " "
                                                                            ),
                                                                          ]
                                                                        )
                                                                      : _c(
                                                                          "span",
                                                                          {
                                                                            staticClass:
                                                                              "text-sm leading-none text-white",
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                _vm.initial
                                                                              ) +
                                                                                " "
                                                                            ),
                                                                          ]
                                                                        ),
                                                                  ]
                                                                ),
                                                              ]
                                                            },
                                                            {
                                                              defaultClasses: [
                                                                _vm.defaultInitialsClasses,
                                                                _vm.avatarStyleClasses,
                                                              ],
                                                            }
                                                          ),
                                                        ],
                                                        2
                                                      ),
                                                    ],
                                              ],
                                              2
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    )
                                  }
                                ),
                                _c(
                                  "RouterLink",
                                  {
                                    staticClass: "hover:text-primary-500",
                                    attrs: { to: _vm.routes.COMPANY_DATABASE },
                                  },
                                  [
                                    _vm.managerDB.newContractors.length > 3
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "flex w-8 h-8 rounded-full border-gray-200 border -m-1 transform hover:scale-125 -mb-3.5 bg-blue-200",
                                          },
                                          [
                                            _c("PlusIcon", {
                                              staticClass:
                                                "fill-current w-2 h-2 mt-2.5 ml-1.5",
                                            }),
                                            _c(
                                              "p",
                                              {
                                                staticClass:
                                                  "mt-1 text-sm font-medium",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.managerDB.newContractors
                                                      .length - 3
                                                  )
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ]
                                ),
                              ],
                              2
                            ),
                          ]
                        )
                      : _vm._e(),
                  ]
                },
                proxy: true,
              }
            : null,
          _vm.isManager
            ? {
                key: "mycontractorsavatarpointers3",
                fn: function () {
                  return [
                    _vm.favorites
                      ? _c(
                          "div",
                          { staticClass: "flex -mt-9 -ml-6 fovourites" },
                          [
                            _c(
                              "div",
                              { staticClass: "flex items-center ml-3" },
                              [
                                _vm._l(
                                  _vm.favorites.contractors.slice(0, 3),
                                  function (i) {
                                    return _c("div", { key: i.id }, [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "rounded-full transform hover:scale-125 -m-1 mt-1",
                                        },
                                        [
                                          _c(
                                            "Tooltip",
                                            {
                                              attrs: {
                                                title:
                                                  _vm.getContractorFullname(
                                                    i.user
                                                  ),
                                                variant:
                                                  _vm.TooltipVariants.DARK,
                                                placement: "top",
                                              },
                                            },
                                            [
                                              i.user.avatar
                                                ? [
                                                    _c(
                                                      "RouterLink",
                                                      {
                                                        attrs: {
                                                          to: {
                                                            name: _vm.routes
                                                              .CONTRACTOR_DETAILS_ABOUT,
                                                            params: {
                                                              id: i.id,
                                                            },
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _vm._t(
                                                          "image",
                                                          function () {
                                                            return [
                                                              _c("S3Image", {
                                                                class: [
                                                                  _vm.defaultImageClasses,
                                                                  _vm.avatarStyleClasses,
                                                                ],
                                                                attrs: {
                                                                  s3FileKey:
                                                                    i.user
                                                                      .avatar,
                                                                },
                                                              }),
                                                            ]
                                                          },
                                                          {
                                                            defaultClasses: [
                                                              _vm.defaultImageClasses,
                                                              _vm.avatarStyleClasses,
                                                            ],
                                                            image:
                                                              i.user.avatar,
                                                          }
                                                        ),
                                                      ],
                                                      2
                                                    ),
                                                  ]
                                                : [
                                                    _c(
                                                      "RouterLink",
                                                      {
                                                        attrs: {
                                                          to: {
                                                            name: _vm.routes
                                                              .CONTRACTOR_DETAILS_ABOUT,
                                                            params: {
                                                              id: i.id,
                                                            },
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _vm._t(
                                                          "initial",
                                                          function () {
                                                            return [
                                                              _c(
                                                                "span",
                                                                {
                                                                  class: [
                                                                    _vm.defaultInitialsClasses,
                                                                    _vm.avatarStyleClasses,
                                                                  ],
                                                                  style:
                                                                    _vm.bgStyle,
                                                                },
                                                                [
                                                                  i.user &&
                                                                  i.user
                                                                    .given_name &&
                                                                  i.user
                                                                    .family_name
                                                                    ? _c(
                                                                        "span",
                                                                        {
                                                                          staticClass:
                                                                            "text-xs leading-none font-semibold text-white",
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            " " +
                                                                              _vm._s(
                                                                                i.user.given_name
                                                                                  .trimStart()[0]
                                                                                  .toUpperCase()
                                                                              ) +
                                                                              _vm._s(
                                                                                i.user.family_name
                                                                                  .trimStart()[0]
                                                                                  .toUpperCase()
                                                                              ) +
                                                                              " "
                                                                          ),
                                                                        ]
                                                                      )
                                                                    : _c(
                                                                        "span",
                                                                        {
                                                                          staticClass:
                                                                            "text-sm leading-none text-white",
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              _vm.initial
                                                                            ) +
                                                                              " "
                                                                          ),
                                                                        ]
                                                                      ),
                                                                ]
                                                              ),
                                                            ]
                                                          },
                                                          {
                                                            defaultClasses: [
                                                              _vm.defaultInitialsClasses,
                                                              _vm.avatarStyleClasses,
                                                            ],
                                                          }
                                                        ),
                                                      ],
                                                      2
                                                    ),
                                                  ],
                                            ],
                                            2
                                          ),
                                        ],
                                        1
                                      ),
                                    ])
                                  }
                                ),
                                _c(
                                  "RouterLink",
                                  {
                                    staticClass: "hover:text-primary-500",
                                    attrs: { to: _vm.routes.COMPANY_DATABASE },
                                  },
                                  [
                                    _vm.favorites.contractors.length > 3
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "flex w-8 h-8 rounded-full border-gray-200 border -m-1 transform hover:scale-125 -mb-4 bg-blue-200",
                                          },
                                          [
                                            _c("PlusIcon", {
                                              staticClass:
                                                "fill-current w-2 h-2 mt-2.5 ml-1.5",
                                            }),
                                            _c(
                                              "p",
                                              {
                                                staticClass:
                                                  "mt-1 text-sm font-medium",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.favorites.contractors
                                                      .length - 3
                                                  )
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ]
                                ),
                              ],
                              2
                            ),
                            _vm._v(" " + _vm._s(_vm.favorites.length) + " "),
                          ]
                        )
                      : _vm._e(),
                  ]
                },
                proxy: true,
              }
            : null,
        ],
        null,
        true
      ),
    },
    [
      _c(
        "CardItemScaffold",
        {
          staticClass: "mb-2 text-innerCard-primary",
          attrs: { itemNumber: _vm.contractorsTotal, itemTitle: "Contractors" },
          scopedSlots: _vm._u([
            {
              key: "icon",
              fn: function () {
                return [
                  _c("SimplePersonIcon", {
                    staticClass: "fill-current text-primary-500 h-5 w-5",
                  }),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _c("ItemChipsWithMore", {
            attrs: {
              items: _vm.contractorsInfo,
              moreNumber: _vm.contractorsTotal,
              navigateTo: { name: _vm.routes.COMPANY_DATABASE },
              maxChipWidth: "max-w-40",
              isPerson: "",
            },
          }),
        ],
        1
      ),
      _c(
        "CardItemScaffold",
        {
          staticClass: "text-innerCard-primary",
          attrs: {
            itemNumber: _vm.newContractorsTotal,
            itemTitle: _vm.newContractorsText,
          },
          scopedSlots: _vm._u([
            {
              key: "icon",
              fn: function () {
                return [
                  _c("SimplePersonIcon", {
                    staticClass: "fill-current text-primary-500 h-5 w-5",
                  }),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _c("ItemChipsWithMore", {
            attrs: {
              showNotAvailable: false,
              items: _vm.newContractors.contractors,
              moreNumber: _vm.newContractors.total,
              routeName: _vm.routes.CONTRACTOR_DETAILS_ABOUT,
              navigateTo: { name: _vm.routes.COMPANY_DATABASE },
              maxChipWidth: "max-w-40",
              isPerson: "",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }